import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChatBotService } from './services/chat-bot.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss'],
  providers: [ChatBotService]
})
export class ChatBotComponent implements OnInit {
  total_messages_list = [];
  loader: boolean = false;
  message_form: UntypedFormGroup = new UntypedFormGroup({
    notes: new UntypedFormControl(null, Validators.required),
    id: new UntypedFormControl(null),
    deleted: new UntypedFormControl(null),
    isEdit: new UntypedFormControl(null)
  })
  constructor(
    private dialog_ref: MatDialogRef<ChatBotComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private api: ChatBotService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    if (this.data && this.data.result) {
      this.total_messages_list = this.data.result || [];
      if (this.total_messages_list && this.total_messages_list.length) {
        setTimeout(() => {
          document.getElementById('chat' + (this.total_messages_list.length - 1)).scrollIntoView({
            behavior: 'smooth'
          });
        })
      }
    } else {
      console.log(this.data)
      if (this.data && this.data.refId && (this.data.refId.length == 0 || !this.data.refId.length)) {
        this.getMessage(this.data);
      }

    }
  }
  getMessage(request) {
    this.api.getMessages(request).subscribe(res => {
      if (res && res['data']) {
        this.loader = false;
        this.total_messages_list = res['data'].list || [];
        if (this.total_messages_list && this.total_messages_list.length) {
          setTimeout(() => {
            document.getElementById('chat' + (this.total_messages_list.length - 1)).scrollIntoView({
              behavior: 'smooth'
            });
          })
        }
      }
    })
  }

  editMessage(chat) {
    this.message_form.patchValue(chat);
    this.message_form.controls.isEdit.patchValue(1)
  }
  cancel() {
    this.message_form.reset();
  }
  deleteMessage(chat) {
    this.message_form.controls.id.patchValue(chat.id);
    this.message_form.controls.deleted.patchValue(1)
    this.sendMessage(this.message_form.value, 1)
  }

  closeChat() {
    this.dialog_ref.close(this.total_messages_list)
  }
  sendMessage(ev?, deleted?) {
    this.loader = true;
    let request = this.data;
    request.notes = this.message_form.value.notes;
    request.id = this.message_form.value.id;
    request.deleted = this.message_form.value.deleted;
    if (this.message_form.valid || deleted) {
      console.log(this.data)
      if (this.data && this.data.refId && this.data.refId.length) {
        request['refIds'] = this.data.refId
      }
      console.log(request)
      this.api.sendMessage(request).subscribe(res => {
        if (res && res['data'] && res['status']) {
          this.message_form.reset();
          this.loader = false;
          if (res['data'].list && res['data'].list.length) {
            let data = res['data'].list[0];
            let index = this.total_messages_list.findIndex(d => d.id == data.id);
            if (index > -1) {
              this.total_messages_list[index] = data;
            }
            else {
              this.total_messages_list.push(data)
            }
          }
          this.total_messages_list = [...this.total_messages_list];
          if (this.total_messages_list && this.total_messages_list.length) {
            setTimeout(() => {
              document.getElementById('chat' + (this.total_messages_list.length - 1)).scrollIntoView({
                behavior: 'smooth'
              });
            })
          }

        }
        else {
          this.notification.error(res['message'], 'Close', 5000)
        }
      }, err => {
        this.loader = false;
      })
    }
    else {
      this.loader = false;
      this.notification.error('Please enter message to proceed', 'Close', 5000)
    }

  }
}
